import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
// import { useSelector } from "react-redux";
// import _, { isEmpty } from "lodash";
import { Accordion, Form, Icon } from "semantic-ui-react";
// import * as kglActions from "kepler.gl/actions";

import "./StoreAttributes.scss";
import * as actions from "./../../store/actions/actions";
import {
  statsBooleanColorPalette,
  statsColorPalette,
  storeAttributes,
} from "./../../store/reducers/dataReducer";

const StoreAttributes = ({
  dispatch,
  kglMap,
  datasetsInfo,
  updateLayerSetting,
  storeStats,
  districtStats,
  analyzeTypes,
  selectedAnalyzeType,
  selectedAttribute,
}) => {
  const { datasets, layers } = kglMap.visState || {};

  const handleSelectAttribute = (a) => {
    dispatch(actions.setSelectedAttribute(a));
  };

  useEffect(() => {
    setActiveIndex(-1);
  }, [selectedAnalyzeType]);

  const [activeIndex, setActiveIndex] = useState(-1);

  const handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const newIndex = activeIndex === index ? -1 : index;
    setActiveIndex(newIndex);
  };

  const form = Object.entries(storeAttributes).map(
    ([groupName, attributes], index) => (
      <React.Fragment key={index}>
        <Accordion.Title
          active={activeIndex === index}
          index={index}
          onClick={handleClick}
        >
          <Icon name="dropdown" />
          {groupName}
        </Accordion.Title>
        <Accordion.Content active={activeIndex === index}>
          <Form.Group grouped>
            {attributes.map((a, index) => (
              <Form.Radio
                key={index}
                label={a}
                name="consumerDemographics"
                type="radio"
                value={a.toLowerCase()}
                checked={selectedAttribute === a}
                onClick={() => handleSelectAttribute(a)}
              />
            ))}
          </Form.Group>
        </Accordion.Content>
      </React.Fragment>
    )
  );

  return (
    <div className="attributesWrap">
      <Accordion exclusive>
        <Form>{form}</Form>
      </Accordion>
    </div>
  );
};

//       {!isEmpty(filteredData) && (

StoreAttributes.defaultProps = {
  kglMap: {},
  datasetsInfo: {},
  dispatch: () => {},
  updateLayerSetting: () => {},
};

StoreAttributes.propTypes = {
  kglMap: PropTypes.object,
  datasetsInfo: PropTypes.object,
  dispatch: PropTypes.func,
  updateLayerSetting: PropTypes.func,
  // filteredData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export default React.memo(StoreAttributes);
